type Props = {
  title: string;
  description?: string;
  children: React.ReactNode;
};

export function SettingsLayout({ title, description, children }: Props) {
  return (
    <div className="p-8 max-w-2xl">
      <header className="mb-8">
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        {description && <p className="text-sm text-muted-foreground mt-1">{description}</p>}
      </header>
      <div className="space-y-6">{children}</div>
    </div>
  );
}
